// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import getColor from "@insite/mobius/utilities/getColor";
import XngQuantityBreakPrice, {
    XngQuantityBreakPriceStyles,
} from "@rugby/App/Components/CustomQuantityBreakPrice/XngQuantityBreakPrice";
import React from "react";
import { css } from "styled-components";

type Props = HasProductContext;

export const xngQuantityBreakPriceWidget: XngQuantityBreakPriceStyles = {
    wraper: {
        css: css`
            border: 1px solid ${getColor("common.border")};
            padding: 4px 8px;
            max-width: 250px;
            min-width: 210px;
            margin-bottom: 8px;
        `,
    },
};
const styles = xngQuantityBreakPriceWidget;
const XngQuantityBreakPriceWidget = ({ productContext }: Props) => {
    return <XngQuantityBreakPrice product={productContext} extendedStyles={styles} />;
};

const widgetModule: WidgetModule = {
    component: withProductContext(XngQuantityBreakPriceWidget),
    definition: {
        displayName: "XngQuantityBreakPrice",
        group: "Xngage Custom" as any,
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
